import get from 'lodash.get';
import keyBy from 'lodash.keyby';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { AppState } from 'services/types';
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
import { selectProductTypesKeyedById } from 'services/productTypes/selectors';
import { ProductsState, ProductsProps, ProductId, Product } from './types';

const selectProducts = (state: AppState): ProductsState => state.products;
const selectProductId = (state: AppState, props: ProductsProps): ProductId =>
    props.productId;

const selectProductsArray = createDeepEqualSelector(
    selectProducts,
    (products) => Object.values(products)
);

const selectProductsKeyedById = createDeepEqualSelector(
    selectProductsArray,
    (productsArray) => keyBy(productsArray, 'id')
);

const selectProduct = createDeepEqualSelector(
    selectProductsKeyedById,
    selectProductId,
    (products, productId): Product | undefined => get(products, productId)
);

const makeSelectProductFieldValue = (fieldName: string): any =>
    createDeepEqualSelector(selectProduct, (product) => {
        return get(product, fieldName);
    });

const makeSelectProductTypeFieldValue = (): any =>
    createDeepEqualSelector(
        selectProduct,
        selectProductTypesKeyedById,
        (product, productTypes) => {
            const typeId = get(product, 'sprayProductTypeId');

            if (!typeId) {
                return undefined;
            }

            const productType = get(productTypes, typeId);

            return get(productType, 'name');
        }
    );

const selectProductsParams = createDeepEqualSelector(
    selectCurrentOrganizationId,
    (currentOrganizationIdState) => ({
        organizationId: currentOrganizationIdState
    })
);

export {
    selectProducts,
    selectProductsParams,
    selectProduct,
    selectProductsArray,
    selectProductsKeyedById,
    selectProductId,
    makeSelectProductFieldValue,
    makeSelectProductTypeFieldValue
};
